import React from 'react';

/**
 * Skeleton loader específico para el botón del mesero
 */
const WaiterButtonSkeleton: React.FC = () => {
  return (
    <div className="fixed bottom-24 left-5 bg-[#22B6B2] text-white rounded-full py-3 px-4 flex items-center shadow-lg animate-pulse">
      <div className="w-6 h-6 bg-white/80 rounded mr-2"></div>
      <div className="w-16 h-4 bg-white/80 rounded"></div>
    </div>
  );
};

export default WaiterButtonSkeleton; 